module.exports = __webpack_public_path__ + "static/media/maks_k.d43e758c.jpg";